<template>
  <div class="QuotationEditTable">
    <template v-if="formValues.unitCode">
      <table class="table-quotation">
        <thead>
          <tr style="vertical-align: top;">
            <th width="25%">行话
              <div class="fs1">(分类)</div>
            </th>
            <th width="25%">规格
              <div class="fs1">({{selectUnit.text || ''}})</div>
            </th>
            <th width="130px">价格<div class="fs1">(元)</div></th>
            <th width="auto"><span style="min-width: 40px">操作</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="fold && quoteValues.length > 0">
            <td colspan="5">
              <div @click="triggerFold" class="row align-items-center justify-content-center fc-danger">
                <span>点击展开全部</span>
                <van-icon name="arrow-down" />
              </div>
            </td>
          </tr>
          <template v-else>
            <tr v-for="(sub, subIndex) in quoteValues" :key="subIndex">
              <!-- 行话 -->
              <td width="28%">
                <template v-if="isQuoteCustom({ value: sub.categorycode, optionKey: 'categories' })">
                  <input v-model="sub.categorycode" class="basic-input" placeholder="请输入" @blur="handleSelectCategory(sub)" />
                </template>
                <template v-else>
                  <select
                    v-model="sub.categorycode"
                    :class="['basic-select', sub.categorycode ? '' : 'select-palceholder']"
                    :placeholder="`请选择`"
                    @change="handleSelectCategory(sub)"
                  >
                    <option :value="null">请选择</option>
                    <option v-for="option in dictOptions.categories" :key="option.value" :value="option.value">{{ option.text }}</option>
                    <option value="">自定义填写</option>
                  </select>
                </template>
              </td>
              <!-- 规格 -->
              <td width="28%">
                <template v-if="isQuoteCustom({ value: sub.weightcode, optionKey: 'weight' })">
                  <input v-model="sub.weightcode" @change="changeWeightcode(sub.weightcode, subIndex)" class="basic-input" placeholder="请输入"/>
                </template>
                <template v-else>
                  <select v-model="sub.weightcode" @change="changeWeightcode(sub.weightcode, subIndex)" :class="['basic-select', sub.weightcode ? '' : 'select-palceholder']" :placeholder="`请选择`">
                    <option :value="null">请选择</option>
                    <option v-for="option in dictOptions.weight" :key="option.value" :value="option.value">{{ option.text }}</option>
                    <option value="">自定义填写</option>
                  </select>
                </template>
              </td>
              <!-- 价格 -->
              <td>
                <!-- <van-stepper v-model="sub.price" :button-size="30" :default-value="0"
                  :step="0.5" :min="(tableData.section === DEFAULT_QUOTE_SECTION && quoteTypeConfig.min ) ? quoteTypeConfig.min : 0" :max="quoteTypeConfig.max || 99999" :input-width="55" /> -->
                <van-stepper v-model="sub.price" :button-size="30" :default-value="0"
                  :step="0.5" :min="(quoteType != 2 && tableData.section === DEFAULT_QUOTE_SECTION && quoteTypeConfig.min ) ? quoteTypeConfig.min : 0" :max="quoteTypeConfig.max || 99999" :input-width="55" />
              </td>
              <td width=""><a @click="resetQuoteRow(subIndex)" class="fc-danger fs4">取消</a></td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="row justify-content-around pl7 pr7">
                  <van-button v-if="valuableQuotes.length>1" @click="showPopup" plain class="btn-common" type="info">调整报价顺序</van-button>
                  <van-button @click="addLine()" plain class="btn-common" type="info"><van-icon name="plus"/> 增加一栏</van-button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </template>
    <div v-else class="padding7 fc-danger text-center">选择重量单位后才可以报价</div>

    <van-popup
      v-model="popupShow"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <h4>调整报价顺序</h4>
      <div class="pl5 pb7 pr5">
        <div class="sort-box">
          <table class="table-quotation">
            <thead>
              <tr style="vertical-align: top;">
                <th width="25%">行话
                  <div class="fs1">(分类)</div>
                </th>
                <th width="25%">规格
                  <div class="fs1">({{selectUnit.text || ''}})</div>
                </th>
                <th width="50%">排序操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sub, subIndex) in sortQuoteValues" :key="subIndex">
                <!-- 行话 -->
                <td width="25%">
                  <template v-if="isQuoteCustom({ value: sub.categorycode, optionKey: 'categories' })">
                    <input disabled v-model="sub.categorycode" class="basic-input sort-input" placeholder="请输入"/>
                  </template>
                  <template v-else>
                    <select disabled v-model="sub.categorycode" :class="['basic-select', 'sort-select']" :placeholder="`请选择`">
                      <option :value="null">请选择</option>
                      <option v-for="option in dictOptions.categories" :key="option.value" :value="option.value">{{ option.text }}</option>
                      <option value="">自定义填写</option>
                    </select>
                  </template>
                </td>
                <td width="25%">
                  <template v-if="isQuoteCustom({ value: sub.weightcode, optionKey: 'weight' })">
                    <input disabled v-model="sub.weightcode" class="basic-input sort-input" placeholder="请输入"/>
                  </template>
                  <template v-else>
                    <select disabled v-model="sub.weightcode" :class="['basic-select', 'sort-select']" :placeholder="`请选择`">
                      <option :value="null">请选择</option>
                      <option v-for="option in dictOptions.weight" :key="option.value" :value="option.value">{{ option.text }}</option>
                      <option value="">自定义填写</option>
                    </select>
                  </template>
                </td>
                <td width="">
                  <div class="row align-items-center">
                    <div class="col-12"><van-button v-if="subIndex>0"
                      @click="goUp(subIndex)" type="info" plain size="small" class="pl5">点我向上&#x2b06;</van-button></div>
                    <div class="col-12"><van-button v-if="subIndex+1<sortQuoteValues.length" @click="goDown(subIndex)" type="info" plain size="small" class="pl5">点我向下&#x2b07;</van-button></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row justify-content-around mt10">
          <van-button @click="closePopup" type="info" class="btn-common" plain>暂不调整</van-button>
          <van-button @click="saveSort" type="info" class="btn-common">保存顺序</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, quoteDict, quoteTypeLast,
} from '@/network/NetworkAccessor';
import { QUOTE_TYPE_MAPPING, DEFAULT_QUOTE_SECTION } from '@/uitls/const';

let allDicts = {};
export default Vue.extend({
  name: 'QuotationEditTable',
  components: {},
  data() {
    return {
      DEFAULT_QUOTE_SECTION,
      quoteTypes: [],
      options: {
        units: [],
        categories: [],
        weight: [],
      },
      quoteValues: [],
      sortQuoteValues: [],
      popupShow: false,
      foldFlag: undefined,
    };
  },
  props: {
    allDicts: {
      type: Object,
      default: () => {},
    },
    quoteType: {
      type: String,
      default: '',
    },
    formValues: {
      type: Object,
      default: () => {},
    },
    selectUnit: {
      type: Object,
      default: () => {},
    },
    from: {
      type: String,
      default: 'quotation', // quotation -报价商报价；market -管理员行情后台报价
    },
    tableData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    fold() {
      // 页面进来默认展开历史报价过的section或者普货, 操作过就按操作结果来展示
      if (this.foldFlag === undefined) {
        // 有效的报价
        const validQuoteValues = this.quoteValues.filter(item => (item.weightcode || item.categorycode) && item.price);
        return (!validQuoteValues || !validQuoteValues.length);
      }
      return this.foldFlag;
    },
    quoteTypeConfig() {
      return QUOTE_TYPE_MAPPING[this.quoteType] || {};
    },
    valuableQuotes() {
      return this.quoteValues.filter(item => item.weightcode || item.categorycode);
    },
    dictOptions() {
      // 处理规格码表，规格和重量单位有关系
      const weight = (this.selectUnit && this.selectUnit.sub) || [];
      // console.log('----this.selectUnit---', this.selectUnit);
      return {
        ...this.options,
        weight,
      };
    },
  },
  watch: {
    quoteType() {
      // this.$set(this.options, 'units');
      this.foldFlag = undefined;
      this.initValues();
      this.initOptions();
    },
    allDicts: {
      deep: true,
      immediate: true,
      handler(value) {
        this.initOptions();
      },
    },
    tableData: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value && (value.formValues || value.quoteValues)) {
          this.quoteValues = value.quoteValues;
        }
      },
    },
    quoteValues: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        // console.log('quoteValues change: ', val, oldVal);
        this.$emit('change', {
          quoteValues: this.quoteValues,
          section: this.tableData ? this.tableData.section : undefined,
          init: !oldVal,
        });
      },
    },
  },
  methods: {

    changeWeightcode(weightCode, index) {
      // 螃蟹报价，第一行的规格变化后，后面行的规格变成同样的规格
      if (this.quoteType == 2 && index === 0) {
        this.quoteValues.forEach((item, itemIndex) => {
          if (itemIndex > 0) {
            this.$set(this.quoteValues, itemIndex, {
              ...item,
              weightcode: weightCode,
            });
          }
        });
      }
    },
    triggerFold() {
      this.foldFlag = !this.fold;
    },
    handleSelectCategory(item) {
      // console.log('handleSelectCategory: ', item, this.quoteValues);
      this.$emit('cateChange', {
        section: this.tableData ? this.tableData.section : undefined,
        quoteValues: this.quoteValues,
      });
    },
    showPopup() {
      this.popupShow = true;
      this.sortQuoteValues = JSON.parse(JSON.stringify(this.valuableQuotes));
    },
    closePopup() {
      this.popupShow = false;
    },
    saveSort() {
      this.quoteValues = JSON.parse(JSON.stringify(this.sortQuoteValues));
      this.closePopup();
    },
    goUp(popupDataIndex) {
      if (!popupDataIndex) {
        return;
      }
      const current = this.sortQuoteValues.splice(popupDataIndex, 1);
      this.sortQuoteValues.splice(popupDataIndex - 1, 0, current[0]);
    },
    goDown(popupDataIndex) {
      if ((!popupDataIndex && popupDataIndex !== 0) || popupDataIndex + 1 >= this.sortQuoteValues.length) {
        return;
      }
      const current = this.sortQuoteValues.splice(popupDataIndex, 1);
      this.sortQuoteValues.splice(popupDataIndex + 1, 0, current[0]);
    },
    addLine(init) {
      if (!init) {
        this.foldFlag = false;
      }
      this.quoteValues.push({
        weightcode: (this.quoteType == 2 && this.quoteValues[0]) ? this.quoteValues[0].weightcode : null,
        categorycode: null,
        price: this.quoteTypeConfig.min || 0,
      });
    },
    // 普货新增行话后，其他种类也添加相同的行话（规格和价格为空） 外部调用
    handleExtendLine(quoteValues) {
      console.log('handleExtendLine: ', quoteValues);
      // 保留行话有值并且规格或者价格有值的 以及 在quoteValues有的数据
      const list = this.quoteValues.filter((val) => {
        const { categorycode, weightcode, price } = val;
        return (categorycode && (weightcode || price)) || quoteValues.find(item => item.categorycode === categorycode);
      });
      // console.log('handleExtendLine1: ', JSON.parse(JSON.stringify(list)), quoteValues);
      // 遍历quoteValues，如果当前没有这个行话的数据，则添加
      quoteValues.forEach((val) => {
        const { categorycode } = val;
        if (categorycode && !list.find(item => item.categorycode === categorycode)) {
          list.push({
            weightcode: null,
            categorycode,
            price: null,
          });
        }
      });
      // console.log('handleExtendLine2: ', JSON.parse(JSON.stringify(list)), quoteValues);
      this.quoteValues = list;
    },
    isCustom(item) {
      const value = this.formValues[item.dataIndex];
      const currentOptions = this.dictOptions[item.optionKey];
      // console.log('value---', item.title, value === '' || !(currentOptions || []).find(v => v.value === value), value, currentOptions);
      return !(value === null || (currentOptions || []).find(v => v.value === value));
    },
    isQuoteCustom({ value, optionKey }) {
      const currentOptions = this.dictOptions[optionKey];
      // console.log(value, currentOptions);
      if (!currentOptions || !currentOptions.length) {
        return true;
      }
      return !(value === null || (currentOptions || []).find(v => v.value === value));
    },
    resetQuoteRow(index) {
      this.foldFlag = false;
      // const findIndex = this.quoteValues.findIndex(item => item.categorycode === itemValue.categorycode && item.weightcode === itemValue.weightcode);
      this.$set(this.quoteValues, index, {
        weightcode: null,
        categorycode: null,
        price: this.quoteTypeConfig.min || 0,
      });
    },
    getDict() {
      // console.log(this.units);
      if (Object.keys(allDicts).length) {
        return allDicts;
      }
      return sendRequest(quoteDict).then((res = {}) => {
        allDicts = res;
      }).catch((e) => {
        console.error(e);
      });
    },
    initOptions() {
      // 处理码表 字典值
      const { priceType = [], ...dicts } = this.allDicts;
      const config = QUOTE_TYPE_MAPPING[this.quoteType] || {};
      const dict = dicts[config.dictCode] || {};
      dict.priceType = priceType;
      this.options = dict;
    },
    initValues() {
      this.quoteValues = [];
      this.addLine(true);
    },
  },
  created() {
  },
});
</script>
<style scoped>
.QuotationEditTable {
}
.QuotationEditTable .select-palceholder {
  color: #a7a9af!important;
}
.QuotationEditTable .border-bottom {
  /* border-bottom: 1px solid #1e67c7; */

}
.basic-select,.basic-textarea,.basic-input {
  width: 100%;
  color: #000000;
  font-size: 18px;
}
.form-item {

}
.form-item-label {
  width: 105px;
  text-align: right;
}
.form-item-label-text.required::before {
  content: '*';
  color: red;
}
.form-item-select,.form-item-textarea,.form-item-input {
  width: 100%;
}

.QuotationEditTable .table-quotation {
  /* margin-top: 15px; */
  width: 100%;
  border-spacing: 0;
  border-radius: 4px;
  border: 1px solid #1e67c7;
  /* border-top: 1px solid #a7a9af;
  border-left: 1px solid #a7a9af;
  border-right: 1px solid #a7a9af; */
}
.table-quotation th {
  text-align: center;
  background-color: #dde1e7;
  /* color: #1e67c7; */
  padding: 6px 0;
  border-bottom: 1px solid #1e67c7;
}
.table-quotation td {
  text-align: center;
  padding: 6px 2px;
  border-bottom: 1px solid #1e67c7;
}
.table-quotation >>> .van-field__right-icon {
  padding: 2px;
  padding-right: 8px;
}
.table-quotation >>> .van-field__right-icon .van-icon {
  font-size: 18px;
}
.table-quotation .quote-item {
  /* max-width: ; */
}
.sort-box .sort-select,.sort-input {
  border: 0;
  appearance:none;
  text-align: center;
  opacity: 1!important;
  color: #000000!important;
}
</style>
